import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import ErrorBoundary from './components/common/ErrorBoundary';
import SkipLink from './components/common/SkipLink';
import SEOHead from './components/common/SEOHead';
import Navbar from './components/layout/Navbar';
import Hero from './components/sections/Hero';
import Services from './components/sections/Services';
import About from './components/sections/About';
import CorporateWellness from './components/sections/CorporateWellness';
import Resources from './components/sections/Resources';
import SocialWall from './components/sections/SocialWall';
import Contact from './components/sections/Contact';
import Footer from './components/layout/Footer';


// Report web vitals in production
if (process.env.NODE_ENV === 'production') {
  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    getCLS(reportWebVitals);
    getFID(reportWebVitals);
    getFCP(reportWebVitals);
    getLCP(reportWebVitals);
    getTTFB(reportWebVitals);
  });
}

function App() {
  const isCorporatePage = typeof window !== 'undefined' && window.location.pathname === '/corporate';

  // Smooth-scroll to hash targets after content renders (for /#services etc.)
  useEffect(() => {
    const scrollToHash = () => {
      const { hash } = window.location;
      if (!hash) return;
      // Wait a tick to ensure sections are in the DOM
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 50);
    };

    // On initial mount
    scrollToHash();
    // On hash changes
    const onHash = () => scrollToHash();
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  return (
    <HelmetProvider>
      <ErrorBoundary>
        <div className="min-h-screen bg-white">
          <SEOHead />
          <SkipLink />
          <Navbar />
          <main id="main-content" role="main">
            {isCorporatePage ? (
              // Standalone Corporate Wellness page
              <CorporateWellness />
            ) : (
              // Homepage
              <>
                <Hero />
                <Services />
                <About />
                <Resources />
                <SocialWall />
                <Contact />
              </>
            )}
          </main>
          <Footer />
        </div>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;